import {
    Box,
    FormControl,
    Grid,
    InputLabel, MenuItem,
} from "@mui/material";
import * as React from "react";
import {useEffect} from "react";
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import {ErrorComponent} from "../../../components/error/error.component";
import {toast} from "react-toastify";
import {Client} from "../../../models/basic/client";
import Select from "@mui/material/Select";
import DragAndDropFileComponent from "../../../components/dnd-file/dnd-file.component";
import {ImportPoMonitoringService} from "../../../services/import-po-service";
import {ImportPo} from "../../../models/basic/import-po";


const AddImportPoComponent = (props: any) => {
    const {
        openDialog,
        handleCloseDialog,
        isDisabled,
        dataSourceClient,
    } = props;

    const service = new ImportPoMonitoringService();
    const [selectedFile, setSelectedFile] = React.useState<File[] | undefined>(undefined);
    const [selectedClient, setSelectedClient] = React.useState<string | undefined>(undefined);
    const [loading, setLoading] = React.useState<boolean>(false);

    useEffect(() => {
    }, []);

    const handleSubmit = () => {
        const formData = new FormData();
        formData.append("client", selectedClient!);
        formData.append("report", selectedFile![0]);
        setLoading(true);
        service.createFormData(formData).then(response => {
            toast.success(translate.t("successfully_registered"));
            setSelectedFile(undefined);
            setSelectedClient(undefined);
            handleCloseDialog(true);
        }).catch((error: any) => {
            ErrorComponent(error);
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleFileUpload = (files: File[]) => {
        setSelectedFile(files);
    };


    return (
        <GenericDialog
            open={openDialog}
            onClose={() => {
                setSelectedFile(undefined);
                handleCloseDialog();
            }}
            title={"import_pos"}
            colorButton={"primary"}
            labelButton={"import"}
            disableConfirm={isDisabled || !selectedFile?.length || !selectedClient || loading}
            loading={loading}
            closeButtonText="close"
            handleConfirm={handleSubmit}>
            <Box>
                <Grid container spacing={2}>
                    <Grid >
                        <FormControl fullWidth>
                            <InputLabel>
                                {translate.t("client")}*
                            </InputLabel>
                            <Select
                                required
                                name="client"
                                label={translate.t("client")}
                                variant={"outlined"}
                                fullWidth
                                autoFocus={false}
                                value={selectedClient}
                                disabled={loading}
                                onChange={(event: any) => setSelectedClient(event.target.value)}
                            >
                                {dataSourceClient?.map((client: Client) => (
                                    <MenuItem key={client.id} value={client.id}>
                                        {client.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Grid marginTop={3}>
                            <DragAndDropFileComponent
                                onFileUpload={handleFileUpload}
                                multiple={false}
                                loading={loading}
                                types={['xlsx']}/>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </GenericDialog>
    )
}

export default AddImportPoComponent;
